import React, { useEffect, useState } from 'react';
import { UiTable, UiSpacer } from 'src/ui';
;;
import { Button, Column, ModalCardBody, ModalCardHeader, ModalCardTitle, ModalCard, ModalBackground, Modal } from 'src/ui/mui-ui-kit';;
import { Form, Field } from 'react-final-form';
import { usePoseWithBulma } from 'src/ui/hooks';
import propTypes from 'prop-types';
import { FadeInDiv, AnimatedCard, UiCheckboxAdapter } from '../../ui';

export function ComplianceTaskEmailTable({
  data,
  isActive,
  onCancel,
  handleUpdateEmails,
  taskId,
  accountName,
}) {
  const [currentPose, isModalVisible, onPoseComplete] = usePoseWithBulma(
    isActive
  );
  const [loading, setLoading] = useState(true);
  const [initialValues, setInitialValues] = useState({});
  const [deleteArr, setDeleteArr] = useState([]);
  const [handleChange, setHandleChange] = useState(false);

  const buildInitialValues = () => {
    const newData = {};
    data.forEach(e => {
      newData[`notifyOnFail_${e.id}`] = e.notifyOnFail;
      newData[`notifyOnPass_${e.id}`] = e.notifyOnPass;
      newData[`notifyOnReview_${e.id}`] = e.notifyOnReview;
      newData[`delete_${e.id}`] = false;
    });
    setInitialValues(newData);
    setLoading(false);
  };
  useEffect(() => {
    if (isActive) {
      buildInitialValues();
    }
  }, [data]);

  const getDifference = (a, b) =>
    Object.fromEntries(
      Object.entries(b).filter(([key, val]) => key in a && a[key] !== val)
    );

  const handleDelete = (e, id) => {
    if (deleteArr.includes(id)) {
      const temp = deleteArr.filter(el => el !== id);
      return setDeleteArr([...temp]);
    }
    return setDeleteArr([...deleteArr, id]);
  };
  const onSubmit = async e => {
    const result = getDifference(initialValues, e);
    handleUpdateEmails(result, taskId);
  };

  const tableColumns = [
    {
      Header: 'Email',
      accessor: 'email',

      filterMethod: (_filter, row) => {
        return [row._original.email].some(v =>
          v.toLowerCase().includes(_filter.value.toLowerCase())
        );
      },
      Cell: row => <div className="account-name">{row.original.email}</div>,
      width: 250,
    },
    {
      Header: 'Fail',
      accessor: 'notifyOnFail',
      filterable: false,
      width: 70,
      resizable: false,
      Cell: row => (
        <Field
          component={UiCheckboxAdapter}
          id={`notifyOnFail_${row.original.id}`}
          name={`notifyOnFail_${row.original.id}`}
          type="checkbox"
          initialValue={row.original.notifyOnFail}
          label=""
          disabled={deleteArr.includes(row.original.id)}
        />
      ),
    },
    {
      Header: 'Pass',
      accessor: 'notifyOnPass',
      filterable: false,
      width: 70,
      resizable: false,
      Cell: row => (
        <div className="has-text-grey-medium-dark">
          <Field
            component={UiCheckboxAdapter}
            id={`notifyOnPass_${row.original.id}`}
            name={`notifyOnPass_${row.original.id}`}
            type="checkbox"
            defaultValue={row.original.notifyOnPass}
            label=""
            disabled={deleteArr.includes(row.original.id)}
          />
        </div>
      ),
    },
    {
      Header: 'Review',
      accessor: 'notifyOnReview',
      filterable: false,
      width: 70,
      resizable: false,
      Cell: row => (
        <div className="has-text-grey-medium-dark">
          <Field
            component={UiCheckboxAdapter}
            id={`notifyOnReview_${row.original.id}`}
            name={`notifyOnReview_${row.original.id}`}
            type="checkbox"
            defaultValue={row.original.notifyOnReview}
            label=""
            disabled={deleteArr.includes(row.original.id)}
          />
        </div>
      ),
    },
    {
      Header: 'Delete',
      accessor: 'id',
      sortable: false,
      width: 70,
      resizable: false,
      filterable: false,
      Cell: row => (
        <Field
          component={UiCheckboxAdapter}
          id={`delete_${row.original.id}`}
          name={`delete_${row.original.id}`}
          type="checkbox"
          defaultValue={false}
          label=""
          onClick={e => handleDelete(e, row.original.id)}
        />
      ),
    },
  ];

  return (
    <>
      <Modal isActive={isModalVisible}>
        <ModalBackground
          tag={FadeInDiv}
          pose={currentPose}
          onPoseComplete={onPoseComplete}
        />

        <ModalCard tag={AnimatedCard} pose={currentPose}>
          <ModalCardHeader>
            <ModalCardTitle
              tag="h5"
              className="has-text-weight-semibold columns is-vcentered"
            >
              <Column tag="span" hasTextColor="primary" isPaddingless>
                {`Edit Notifications for ${accountName}`}
              </Column>
            </ModalCardTitle>
          </ModalCardHeader>
          <ModalCardBody>
            {!loading && isActive && (
              <Form
                onSubmit={onSubmit}
                render={({ form, handleSubmit }) => {
                  return (
                    <>
                      <form
                        onSubmit={handleSubmit}
                        onChange={() => setHandleChange(true)}
                      >
                        <UiTable
                          className="people-table -highlight"
                          isAlign="right"
                          columns={tableColumns}
                          data={data}
                          useTablePagination
                          title="Emails"
                          resolveData={data =>
                            data?.map(transaction => ({
                              ...transaction,
                            }))
                          }
                          hidePrev
                          hideNext
                          hideButton
                          filterable
                          pageSize={8}
                        />
                        <UiSpacer />
                        <Button
                          style={{ marginRight: '5px' }}
                          hasTextColor="info"
                          onClick={() => onCancel(form)}
                        >
                          Cancel
                        </Button>
                        <Button
                          isColor="gradient-bright"
                          type="submit"
                          disabled={!handleChange}
                        >
                          Submit
                        </Button>
                        <UiSpacer />
                      </form>
                    </>
                  );
                }}
              />
            )}
          </ModalCardBody>
        </ModalCard>
      </Modal>
    </>
  );
}

ComplianceTaskEmailTable.propTypes = {
  data: propTypes.array.isRequired,
  isActive: propTypes.bool.isRequired,
  onCancel: propTypes.func.isRequired,
  handleUpdateEmails: propTypes.func.isRequired,
  taskId: propTypes.number.isRequired,
  accountName: propTypes.string.isRequired,
};
